module.exports = __webpack_public_path__ + "img/green-beam.c51406cd.png";